import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abe5abec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex"} }
const _hoisted_2 = {
  key: 0,
  class: "dv-title-index"
}
const _hoisted_3 = {
  key: 1,
  class: "dv-title-score"
}
const _hoisted_4 = { class: "dv-options" }
const _hoisted_5 = {
  key: 0,
  class: "question-correct_answer"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "correct_answer-title" }, "正确答案:", -1))
const _hoisted_7 = { class: "correct_answer-content" }
const _hoisted_8 = {
  key: 1,
  class: "cq-question-analysis"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cq-analysis-title" }, "解析:", -1))
const _hoisted_10 = ["innerHTML"]

import _ from "lodash";
import { computed, nextTick, onMounted, ref, watch } from "vue";
import { Node, Edge, Graph, Shape } from "@antv/x6";
import { VueShape } from "@antv/x6-vue-shape";
import useAntvX6 from "@/hooks/useAntvX6";
import useCompileContent from "@/hooks/useCompileContent";
// import useAutoScroll from "@/hooks/useAutoScroll";
import DynamicContent from "./DynamicContent.vue";
import { unLock } from "@/utils/liner-lock";
import { getScaleRate } from "@/utils/rem";


export default /*#__PURE__*/_defineComponent({
  props: {
  question: {
    type: Object,
  },
  disabled: {
    type: Boolean,
  },
  showQuestionNum: {
    type: Boolean,
    default: true,
  },
  showQuestionScore: {
    type: Boolean,
    default: true,
  },
},
  setup(__props, { expose }) {

const props = __props


const scale = getScaleRate();
const { initGraph } = useAntvX6();
const { compileQuestionTitle } = useCompileContent();
const question = ref(props.question || {});

// * 图形相关
const container = ref<HTMLDivElement>();
const graph = ref<Graph | null>(null);

// * 组织数据
const nodes = ref<Node[]>([]);
const edges = ref<Edge[]>([]);

// * 当前已经点击的连接桩信息
const currentPort = ref<{ nodeId: string; portId: string }>();

const organizationNodesAndLines = () => {
  /**
   * 1. 根据具体宽度，计算出每个node line 所需要的宽度
   * 2. 根据题干的数据进行nodes的整理
   * 3. 根据回答的答案进行lines的整理
   */

  const containerWidth = container.value?.offsetWidth || 0;
  const { items: allNodeItems = [], correct_lines = [] } =
    question?.value?.question_params || {};
  // * 整理节点
  const nodeItems = Object.values(
    _.groupBy(allNodeItems, "column_group") || {}
  ).map((nodes) => _.orderBy(nodes, "sort"));

  const nodeItemsLen = nodeItems.length;
  if (nodeItemsLen == 0) {
    console.warn("没有节点数据");
    return;
  }
  const allBockerNum = nodeItemsLen + (nodeItemsLen - 1);
  const avgBockWidth = containerWidth / allBockerNum;
  let x = 0;
  const nodeHeight = 200 * scale;
  const rowMargin = 50 * scale;
  nodeItems.forEach((sourceNodes, nodesIndex) => {
    let y = 0;
    const width = avgBockWidth;
    const portPosition =
      nodesIndex === 0
        ? "right"
        : nodesIndex + 1 === nodeItemsLen
        ? "left"
        : "all";
    sourceNodes.forEach((node) => {
      nodes.value.push(
        createNode(x, y, width, nodeHeight, { ...node, portPosition })
      );
      y += nodeHeight + rowMargin;
    });
    x = (nodesIndex * 2 + 2) * width;
  });

  // * 整理连线
  const { lines: answers = [] } = question.value.answer_params || {};
  console.log("lines", answers);
  console.log("lines1", question.value);
  answers.forEach((answer: any) => {
    const data = {
      data1: allNodeItems.find((node: any) => node.id === answer.item_1_id),
      data2: allNodeItems.find((node: any) => node.id === answer.item_2_id),
      isCorrect: !!correct_lines.find(
        (line: any) =>
          (line.item_1_id === answer.item_1_id &&
            line.item_2_id === answer.item_2_id) ||
          (line.item_1_id === answer.item_2_id &&
            line.item_2_id === answer.item_1_id)
      ),
    };
    if (!data.data1 || !data.data2) {
      return;
    }
    edges.value.push(creatEdge(answer, data));
  });
};

// * 图形相关创建方法
const createGraph = () => {
  if (graph.value) {
    graph.value.addNodes(nodes.value as any);
    graph.value.addEdges(edges.value);
    handleFillPortIfHaveConnect();
    const svg = graph.value!.view.svg;
    // 直接修改画布的高度，使得容器撑开触发滚动
    graph.value.resize(undefined, svg.getBBox().height);
  }
};

const createNode = (
  x: number,
  y: number,
  width: number,
  height: number,
  data: any
) => {
  const getPortItem = (
    portPosition: "left" | "right" | "all" = "all",
    data: any
  ) => {
    const leftPort = {
      id: `${data.column_group}-${data.id}-left`,
      group: "left",
    };

    const rightPort = {
      id: `${data.column_group}-${data.id}-right`,
      group: "right",
    };
    let ports = [];
    switch (portPosition) {
      case "right":
        ports = [rightPort];
        break;
      case "left":
        ports = [leftPort];
        break;
      case "all":
        ports = [leftPort, rightPort];
        break;
    }
    return ports;
  };
  return new VueShape(
    _.merge(
      {
        size: {
          width,
          height,
        },
        position: {
          x,
          y,
        },
        shape: "vue-shape",
        component: {
          template:
            "<DynamicContent :isResizeImgToRem='false' v-bind='data'></DynamicContent>",
          setup() {
            return {
              data: {
                title: `序号：${data.column_group + 1}.${data.sort}`,
                ...data,
              },
            };
          },
          components: {
            DynamicContent,
          },
        },
        data,
        ports: {
          groups: {
            left: {
              position: {
                name: "leftPort",
              },
              attrs: {
                circle: !props.disabled
                  ? {
                      r: 20 * scale,
                      event: "port:click",
                      stroke: "#1ac36e",
                    }
                  : {
                      r: 20 * scale,
                      stroke: "#1ac36e",
                    },
              },
            },
            right: {
              position: {
                name: "rightPort",
              },
              attrs: {
                circle: !props.disabled
                  ? {
                      r: 20 * scale,
                      event: "port:click",
                      stroke: "#1ac36e",
                    }
                  : {
                      r: 20 * scale,
                      stroke: "#1ac36e",
                    },
              },
            },
          },
          items: getPortItem(data.portPosition, data),
        },
      },
      data || {},
      {
        id: `${data.id}-node`,
      }
    )
  );
};

const creatEdge = (edge: any, data: any) => {
  let option = {};
  if (data.data1.column_group < data.data2.column_group) {
    option = {
      source: {
        cell: `${edge.item_1_id}-node`,
        port: `${data.data1.column_group}-${data.data1.id}-right`,
      },
      target: {
        cell: `${edge.item_2_id}-node`,
        port: `${data.data2.column_group}-${data.data2.id}-left`,
      },
    };
  } else {
    option = {
      source: {
        cell: `${edge.item_1_id}-node`,
        port: `${data.data1.column_group}-${data.data1.id}-left`,
      },
      target: {
        cell: `${edge.item_2_id}-node`,
        port: `${data.data2.column_group}-${data.data2.id}-right`,
      },
    };
  }

  return new Shape.Edge(
    _.merge(option, {
      id: `${edge.item_1_id}-${edge.item_2_id}-edge`,
      data,
      attrs: {
        line: {
          strokeWidth: 5 * scale,
          stroke: !props.disabled
            ? "#1ac36e"
            : data.isCorrect
            ? "#1ac36e"
            : "red",
        },
      },
      label: !props.disabled ? "删除" : "",
    })
  );
};

const onEdgeClick = ({ e, edge }: { e: any; edge: Edge }) => {
  if (e.type === "touchstart" || e.type === "touchend") {
    return;
  }
  if (!props.disabled) {
    const sourceNode = edge.getSourceNode();
    const targetNode = edge.getTargetNode();
    const sourcePortId = edge.getSourcePortId();
    const targetPortId = edge.getTargetPortId();
    // 取消连接桩高亮
    if (sourceNode && targetNode && sourcePortId && targetPortId) {
      unHighlightPort({ nodeId: sourceNode.id, portId: sourcePortId });
      unHighlightPort({ nodeId: targetNode.id, portId: targetPortId });
    }

    graph.value?.removeEdge(edge.id);
  }
};

// 根据连线的情况控制连接桩的颜色
const handleFillPortIfHaveConnect = () => {
  const edges = graph.value?.getEdges() || [];

  edges.forEach((edge) => {
    const { isCorrect = true } = edge.getData();
    let color = "#1ac36e";
    // 答案模式,且为错误则使用红色
    if (props.disabled && isCorrect === false) {
      color = "red";
    }
    const sourceNode = edge.getSourceNode();
    const sourcePortId = edge.getSourcePortId();
    if (sourceNode && sourcePortId) {
      sourceNode.setPortProp(sourcePortId, "attrs/circle", {
        fill: color,
        stroke: color,
      });
    }
    const targetNode = edge.getTargetNode();
    const TargetPortId = edge.getTargetPortId();
    if (targetNode && TargetPortId) {
      targetNode.setPortProp(TargetPortId, "attrs/circle", {
        fill: color,
        stroke: color,
      });
    }
  });
};

// * 高亮指定的连接桩
const highlightPort = ({
  nodeId,
  portId,
}: {
  nodeId: string;
  portId: string;
}) => {
  const node = graph.value?.getCellById(nodeId) as Node;
  if (node && node.setPortProp) {
    node.setPortProp(portId, "attrs/circle", { fill: "#1ac36e" });
  }
};

// * 取消连接桩高亮
const unHighlightPort = ({
  nodeId,
  portId,
}: {
  nodeId: string;
  portId: string;
}) => {
  const node = graph.value?.getCellById(nodeId) as Node;
  if (node && node.setPortProp) {
    node.setPortProp(portId, "attrs/circle", { fill: "transparent" });
  }
};

// 检查某个连接桩是否有连线
const hasConnectEdgeByPort = (nodeId: string, portId: string) => {
  const edges = graph.value?.getConnectedEdges(nodeId) || [];
  let flag = false;
  edges.forEach((edge) => {
    if (
      edge.getSourcePortId() === portId ||
      edge.getTargetPortId() === portId
    ) {
      flag = true;
    }
  });
  return flag;
};

// * 连接桩点击事件
const onPortClick = ({ e, cell, x }: any) => {
  if (e.type === "touchstart" || e.type === "touchend") {
    return;
  }
  e.stopPropagation();
  const { x: nodeX } = cell.position();
  let portGroupPrefix;
  const nodeData = cell.getData();
  if (x <= nodeX) {
    portGroupPrefix = "left";
  } else {
    portGroupPrefix = "right";
  }
  const portId = `${nodeData.column_group}-${nodeData.id}-${portGroupPrefix}`;
  if (hasConnectEdgeByPort(cell.id, portId) !== false) {
    return;
  }
  // * 上次有没有点击连接桩
  if (currentPort.value === undefined) {
    currentPort.value = {
      nodeId: cell.id,
      portId: portId,
    };
    // 高亮当前点击的连接桩
    highlightPort(currentPort.value);
    return;
  }

  // 判断当前点击的连接桩是否是上一次点击的
  const lastPort = currentPort.value;
  if (lastPort.portId === portId) {
    unHighlightPort(lastPort);
    currentPort.value = undefined;
    return;
  }

  // 两个不同的连接点，判断是否允许连接，如果可以，则创建一条连线
  const targetPort = portId;
  const sourcePort = lastPort.portId;
  const sourceNode = graph.value?.getCellById(lastPort.nodeId) as Node;

  // 允许连接：创建边连接进入
  if (onValidateConnection({ targetPort, sourcePort })) {
    const sourceData = sourceNode.getData();
    const targetData = cell.getData();
    const data = {
      data1: sourceData,
      data2: targetData,
    };
    const edgeConfig = {
      item_1_id: sourceData.id,
      item_2_id: targetData.id,
    };
    const edge = creatEdge(edgeConfig, data);
    graph.value?.addEdge(edge);
    edges.value.push(edge);
    currentPort.value = undefined;
    highlightPort({ nodeId: cell.id, portId: portId });
  }
};

const onValidateConnection = (e: any) => {
  const { sourcePort, targetPort } = e;
  if (!sourcePort || !targetPort) {
    return false;
  }

  const [scolumn_group, sid, sportPosition] = sourcePort.split("-");
  const [tcolumn_group, tid, tportPosition] = targetPort.split("-");
  if (
    scolumn_group &&
    sid &&
    sportPosition &&
    tcolumn_group &&
    tid &&
    tportPosition &&
    scolumn_group !== tcolumn_group &&
    sid !== tid &&
    sportPosition !== tportPosition &&
    Math.abs(tcolumn_group - scolumn_group) == 1
  ) {
    const edges = graph.value?.getEdges() || [];
    const datas = edges.map((edge) => edge.data).filter(Boolean);
    const isConnected = datas.find(
      (data) => `${data.data1.id}` === sid && `${data.data2.id}` === tid
    );
    return isConnected ? false : true;
  }
  return false;
};

// * 处理自动边缘自动滚动
const scrollEL = ref<HTMLElement>();

// * 标题编译
const questionTitle = ref<HTMLDivElement>();
compileQuestionTitle(questionTitle, question.value.title || "");

// * 获取答案
const getEdgesAnswers = () => {
  const edges = graph.value?.getEdges() || [];
  return edges.map((edge) => ({
    item_1_id: edge.data.data1.id,
    item_2_id: edge.data.data2.id,
  }));
};

const isAnswerDataSame = (edgesAnswers: any) => {
  console.log("edgesAnswers", edgesAnswers);
  console.log("question.value", question.value);
  const oldAnswers = (question.value.answer_params || {}).lines || [];

  if (edgesAnswers.length !== oldAnswers.length) {
    return false;
  }
  return edgesAnswers.every((value: any) => {
    const oldAnswer = oldAnswers.find(
      (oldAnswer: any) =>
        oldAnswer.item_1_id === value.item_1_id &&
        oldAnswer.item_2_id === value.item_2_id
    );
    console.log("oldAnswer", oldAnswer);
    return !!oldAnswer;
  });
};
const getAnswer = () => {
  const edgesAnswers = getEdgesAnswers();
  if (!question.value.answer_params) {
    //* 没有回答过答案
    if (edgesAnswers.length == 0) {
      //* 内容一样 代表没有碰过答案
      return { type: 0 };
    }
    return {
      type: 1,
      answer_params: {
        lines: edgesAnswers,
      },
    };
  } else {
    //* 回答过答案
    if (isAnswerDataSame(edgesAnswers)) {
      //*  跟之前答过的一样
      return { type: 0 };
    }

    if (edgesAnswers.length === 0) {
      return {
        type: 1,
        answer_params: undefined,
      };
    }

    return {
      type: 1,
      answer_params: {
        lines: edgesAnswers,
      },
    };
  }
};

// * 正确答案处理
const correct_answers = computed(() => {
  const { correct_lines = [], items = [] } = question.value.question_params;
  return correct_lines
    .map((answer: any) => {
      const { item_1_id, item_2_id } = answer;
      const item1 = items.find((item: any) => item.id === item_1_id);
      const item2 = items.find((item: any) => item.id === item_2_id);
      const itemss = _.sortBy([item1, item2], "column_group", "asc");
      return itemss
        .map((item) => `${item.column_group + 1}.${item.sort}`)
        .join("~");
    })
    .join("; ");
});

watch(
  () => props.disabled,
  () => {
    if (graph.value) {
      graph.value?.clearCells();
      // 更新新保存的连线信息
      question.value = props.question || {};
      nodes.value = [];
      edges.value = [];
      organizationNodesAndLines();
      createGraph();
    }
  }
);
expose({ getAnswer });

onMounted(async () => {
  console.log("组建里接到的答案", question.value);
  await nextTick();
  graph.value = initGraph(
    container.value!,
    {
      // "edge:connected": onEdgeconnected,
      "edge:click": onEdgeClick,
      "port:click": onPortClick,
    },
    {}
  );
  Shape.Edge.config({
    attrs: {
      line: {
        targetMarker: {
          name: "ellipse", // 椭圆
          rx: 0.1, // 椭圆箭头的 x 半径
          ry: 0.1, // 椭圆箭头的 y 半径
        },
        stroke: "#1ac36e",
      },
    },
  });
  organizationNodesAndLines();
  createGraph();
  unLock();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "dv-question-title",
    ref_key: "scrollEL",
    ref: scrollEL
  }, [
    _createElementVNode("div", _hoisted_1, [
      (props.showQuestionNum)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(question.value.indexInQuestion !== undefined
            ? question.value.indexInQuestion + "."
            : "") + _toDisplayString(question.value.titleNum > 0 ? question.value.titleNum : ""), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        id: "dvCompile",
        class: "dv-title",
        ref_key: "questionTitle",
        ref: questionTitle
      }, null, 512),
      (props.showQuestionScore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " (" + _toDisplayString(question.value.score) + "分) ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "graph-container",
        ref_key: "container",
        ref: container
      }, null, 512)
    ]),
    (props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(correct_answers)), 1)
        ]))
      : _createCommentVNode("", true),
    (props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", {
            class: "cq-analysis-content",
            innerHTML: question.value?.analysis || ''
          }, null, 8, _hoisted_10)
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})